import React from "react";
import styled from "styled-components";
import { DeviceWidth, mobileQuery, useDeviceWidthQuery } from "../MediaQuery";
import analytics from "../services/analytics";
import { SlantedSection } from "./SlantedSection";

export const PromoVideoSection: React.FC = () => {
  const deviceWidth = useDeviceWidthQuery();

  return (
    <VideoWrapper>
      <VideoPlayer
        src="https://storage.googleapis.com/vika-web/vika2.mp4"
        controls
        controlsList="nodownload"
        poster="home/video-poster.jpg"
        preload="metadata"
        onPlay={() => {
          analytics.logVideoPlay();
        }}
        onPause={() => {
          analytics.logVideoPause();
        }}
        onSeeked={() => {
          analytics.logVideoSeek();
        }}
      />
      {deviceWidth === DeviceWidth.desktop && (
        <div
          style={{
            position: "absolute",
            zIndex: 1,
          }}
        >
          <SlantedSection
            offset={250}
            height={530}
            width={1300}
            gradient={true}
            skewLeft={true}
            justifyContent="center"
          ></SlantedSection>
        </div>
      )}
    </VideoWrapper>
  );
};

const VideoWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const VideoPlayer = styled.video`
  width: 100%;
  max-width: 780px;
  z-index: 10;

  &:focus {
    outline: none;
  }

  ${mobileQuery`
    max-width: 640px;
  `}
`;
